export default {
    title: "Orders",
    search: "Search orders",
    paginatorText: "orders",
    status: {
        processing: "Processing"
    },
    table: {
        orderNumber: "Order Number",
        orderDate: "Order Date",
        quantity: "Quantity",
        price: "Price",
        municipality: "Municipality",
        status: "Status",
        refund: 'Refund',
        pending: 'Pending',
        denied: 'Denied',
        approved: 'Refunded'
    },
    filters: {
        allMonths: 'All months',
        allMunicipalities: 'All municipalities',
        allStatuses: 'All statuses',
    },
    orderOverview: {
        title: "Order overview",
        button: {
            close: "Close",
            cancel: "Cancel",
            changeStatus: "Change Status",
            sendMessage: "Send buyer a message"
        },

        details: {
            title: "Order details",
            orderNumber: "Order number",
            date: "Order date",
            productNumber: "Product number",
            quantity: "Total quantity",
            price: "Order price",
            delivery: "Delivery",
            supplement: "Supplement",
            total: "Total"
        },

        note: "Note",

        paymentDetails: {
            title: "Payment details",
            paymentMethod: 'Payment method',
            cashOnDelivery: "By cash on delivery",
            creditCard: "Credit card",
            successful: 'successful',
            unsuccessful: 'unsuccessful',
            status: 'Status',
            code: 'Transaction code',
            date: 'Transaction date'
        },

        customerDetails: {
            title: "Customer Details",
            name: "Name and surname",
            city: "City",
            address: "Address",
            phone: "Phone number",
            email: "Email"
        },
    },
    orderStatus: {
        title: "Order status",
        subtitle: "Choose new order status.",
        packed: "It is packed",
        transit: "In transit",
        button: {
            close: "Close",
            confirm: "Confirm",
        },
        info: "After the change, the new status cannot be returned to the previous one.",
        cannotBeCanceled: "After changing to any of these statuses, the order cannot be canceled.",
    },
    orderStatuses: {
        processed: "Processed",
        packaging: "Packaging",
        canceled: "Canceled",
        in_transit: "In transit",
        delivered: "Delivered",
        confirmed: "Confirmed"
    },
    cancelOrder: {
        title: "Order cancellation",
        description: "Are you sure you want to cancel this order? This action is permanent and cannot be changed.",
        button: {
            close: "Close",
            cancel: "Cancel",
        },
    },
    requestRefundModal: {
        title: "Request Refund",
        cancel: "Cancel",
        send: "Send",
        message: "Message",
        messagePlaceholder: "Add details"
    }
}
